module.exports = __webpack_public_path__ + "static/media/mini.41b77b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E6/mini.png
// module id = 693
// module chunks = 0